import { render, staticRenderFns } from "./ModifyPasswd.vue?vue&type=template&id=53019deb&scoped=true&"
import script from "./ModifyPasswd.vue?vue&type=script&lang=js&"
export * from "./ModifyPasswd.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPasswd.vue?vue&type=style&index=0&id=53019deb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53019deb",
  null
  
)

export default component.exports